export default "__VITE_ASSET__e290d1b9__"